import React from 'react';
import Title from '../../components/title/Title';

import './EsqueceuSenha.css';

const EsqueceuSenha = () => {

    return (
        <div className='background'>
            <Title title='Recuperação de senha' />
            <div className="container">
                <div className="content">
                    <div className="text">Insira seu e-mail abaixo para redefinir sua senha</div>
                    <form className='form-esqueceusenha' action="" onSubmit={(e) => { e.preventDefault() }}>
                        <div className='fields'>
                            <input className='field' type="text" placeholder='E-mail' />
                        </div>
                        <div className="captcha">CAPTCHA</div>
                        <div className="button">
                            <button type='button' className='forward'>Enviar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
};

export default EsqueceuSenha;
